
import { defineComponent, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { consts } from "../services/Models";

export default defineComponent({
  name: "AdminLogin",
  components: { ErrorMessage },
  setup() {
    const login = store.useLoginStore();
    const auth = store.useAuthStore();
    const router = useRouter();
    const email = ref("");
    const password = ref("");
    const isLoginFailure = ref(false);
    const errorMessages = computed(() => ({
      LoginError: isLoginFailure.value ? [consts.adminLoginFailure] : [],
    }));

    const signin = async () => {
      isLoginFailure.value = !(await login.signin(
        email.value,
        password.value,
        true
      ));
      // ログイン成功したら管理Topに遷移
      if (auth.state.isLoggedin) {
        router.push({
          name: routeNames.AdminContract,
        });
      }
    };

    return {
      email,
      password,
      signin,
      isLoginFailure,
      errorMessages,
    };
  },
});
